import { defineComponent as _defineComponent } from 'vue'
import OzDrawerDraggable from 'library/v4/components/OzDrawerDraggable.vue'
import OzTextButton, { OzTextButtonColorScheme } from 'library/v4/components/OzTextButton.vue'
import OzOverlay from 'library/v4/components/OzOverlay.vue'
import { storeToRefs } from 'pinia'
import { useWindowSizeStore } from 'pinia/window_size'
import { useReactionsStore } from 'pinia/surface_reactions'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfaceDropdownReactionBase',
  props: {
    usageContext: null,
    preferredModalModeHeight: null,
    dropdownLabel: null,
    closeButtonAriaLabel: { default: '' },
    submitButtonAriaLabel: { default: '' },
    modalModeTitle: null,
    isPadletColorSchemeDark: { type: Boolean },
    xModalModeSubmitButton: { type: Boolean, default: false },
    canSubmit: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { usageContext: 'postView' | 'postExpandedView', preferredModalModeHeight: number, dropdownLabel: string, closeButtonAriaLabel: string, submitButtonAriaLabel: string, modalModeTitle: string, isPadletColorSchemeDark: boolean, xModalModeSubmitButton: boolean, canSubmit: boolean }



const isSmallerThanTabletPortrait = storeToRefs(useWindowSizeStore()).isSmallerThanTabletPortrait
const windowHeight = storeToRefs(useWindowSizeStore()).windowHeight
const isUsedInPostExpandedView = computed(() => props.usageContext === 'postExpandedView')
const { reactionDropdownTop, reactionDropdownLeft, reactionDropdownWidth } = storeToRefs(useReactionsStore())
const { stopEditingReaction } = useReactionsStore()
const dropdownStyle = computed(() => {
  if (isSmallerThanTabletPortrait.value) {
    return {
      bottom: 'env(safe-area-inset-bottom, 0px)',
      left: '0px',
      right: '0px',
    }
  }
  return {
    left: `${reactionDropdownLeft.value}px`,
    top: `${reactionDropdownTop.value}px`,
    minWidth: `${reactionDropdownWidth.value}px`,
  }
})
function handleModalModeCancel(): void {
  // we only close the modal on non mobile devices since it's too easy to have a mis-tap outside of the modal
  if (!isSmallerThanTabletPortrait.value) {
    stopEditingReaction()
  }
}

return { __sfc: true,props, isSmallerThanTabletPortrait, windowHeight, isUsedInPostExpandedView, reactionDropdownTop, reactionDropdownLeft, reactionDropdownWidth, stopEditingReaction, dropdownStyle, handleModalModeCancel, OzDrawerDraggable, OzTextButton, OzTextButtonColorScheme, OzOverlay }
}

})